import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'

export default class extends Controller {
  static targets = ['queueChart']

  static values = {
    url: String
  }

  charts = {}

  connect() {
    this.loadData()
  }

  disconnect() {
    Object.values(this.charts).forEach((chart) => chart.destroy())
    this.charts = {}
  }

  async loadData() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin'
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      this.renderChart(data)
    } catch (error) {
      console.error('Failed to load queue metrics:', error)
    }
  }

  renderChart(data) {
    if (!this.hasQueueChartTarget || !data.queue_trend || data.queue_trend.length === 0) {
      if (this.hasQueueChartTarget) {
        this.queueChartTarget.innerHTML =
          '<p class="text-sm text-slate-400">No queue data available</p>'
      }
      return
    }

    const canvas = document.createElement('canvas')
    this.queueChartTarget.innerHTML = ''
    this.queueChartTarget.appendChild(canvas)

    const queueTrend = data.queue_trend
    const labels = queueTrend.map((d) => this.formatDate(d.date))
    const created = queueTrend.map((d) => d.created)
    const resolved = queueTrend.map((d) => d.resolved)

    this.charts.queue = new Chart(canvas, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Created',
            data: created,
            backgroundColor: '#F59E0B',
            borderWidth: 0,
            borderRadius: 2
          },
          {
            label: 'Resolved',
            data: resolved,
            backgroundColor: '#10B981',
            borderWidth: 0,
            borderRadius: 2
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              boxWidth: 12,
              padding: 8,
              font: { size: 10 }
            }
          }
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              font: { size: 9 },
              maxRotation: 0,
              maxTicksLimit: 10
            }
          },
          y: {
            beginAtZero: true,
            grid: { color: '#E2E8F0' },
            ticks: { font: { size: 9 } }
          }
        }
      }
    })
  }

  formatDate(dateStr) {
    const date = new Date(dateStr)
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  }
}
